/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { object } from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useDispatch } from 'react-redux';
import landerCss from './Lander.module.css';
import Features from '../../Components/Features/Features';
import Banners from '../../Components/Banners/Banners';
import Tiles from '../../Components/Tiles/Tiles';
import SubCollections from '../../Components/Merchandising/SubCollection/SubCollection';
import UniversalGiftFinder from '../../../GraphqlHomePage/Partials/GraphqlFindAGiftFast/GraphqlFoodGiftFinder';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const Lander = ({
    rows, page, trackData,
}) => {
    useStyles(landerCss);

    const classes = `
        ${landerCss.root}
        ${page.page_settings?.page_margin ? landerCss.topMargin : ''}
        `;

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(trackEvent({
            eventCategory: trackData?.tracking_event_category || '',
            eventAction: trackData?.tracking_event_action || '',
            eventLabel: trackData?.tracking_event_label || '',
        }));
    }, []);
    return (
        <>
            <div className={classes}>
                {
                    rows.map((row) => {
                        const rowType = Object.keys(row)?.[0];
                        if (rowType === 'banner') return <Banners data={row} />;
                        if (rowType === 'product_feature') return <Features data={row} />;
                        if (rowType === 'tiles') return <Tiles data={row} />;
                        if (rowType === 'merchandising') return <SubCollections data={row} />;
                        if (rowType === 'interactive') return <UniversalGiftFinder data={row?.interactive} isUniversalLander ulGiftFinderCss={landerCss.ulGiftFinderCss} />;
                        return <></>;
                    })
                }
            </div>
        </>
    );
};

Lander.propTypes = {
    rows: object.isRequired,
    page: object.isRequired,
    trackData: object,
};
Lander.defaultProps = {
    trackData: {},
};

export default Lander;
